





























































import { Component, Prop, Vue } from 'vue-property-decorator';
import swal from 'sweetalert2';

@Component({
    name: 'ModalFooter'
})

export default class ModalFooter extends Vue {}
